export default "__VITE_ASSET__CCpEem5v__"